import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { COLORS } from "../../../utilities/Constants"
import { fetchMissionAssistance } from "../../../store/actions/assistancesActions"
import DepMissionCardV2 from "../dispatch/DepMissionCardV2"

// Onglet Assistances (demande Jordan 09.10) : une mission Mxxx affichée
// (panneau Dossier, fenêtre de proposition) se déplie en sa carte complète
// du dispatch, en LECTURE seule. Chargée au premier dépliage
// (api/assistances/missions/<id>), gardée tant que le composant vit.

// Petit chevron ▸ / ▾ à poser à côté du libellé de la mission.
export const ChevronMission = ({ ouvert, onClick, missionId }) => (
	<button
		type="button"
		onClick={(e) => {
			e.stopPropagation()
			onClick()
		}}
		aria-expanded={ouvert}
		aria-label={`${ouvert ? "Replier" : "Déplier"} la mission M${missionId}`}
		title={ouvert ? "Replier la carte" : "Voir la carte complète"}
		style={st.chevron}
	>
		{ouvert ? "▾" : "▸"}
	</button>
)

// Zone dépliée : la carte de la mission (pleine largeur du conteneur).
export const CarteMissionDepliee = ({ missionId }) => {
	const dispatch = useDispatch()
	const [etat, setEtat] = useState({ mission: null, erreur: null })
	const monte = useRef(true)
	useEffect(
		() => () => {
			monte.current = false
		},
		[],
	)
	useEffect(() => {
		setEtat({ mission: null, erreur: null })
		dispatch(fetchMissionAssistance(missionId)).then((res) => {
			if (!monte.current) return
			if (!res || res.erreur)
				setEtat({
					mission: null,
					erreur:
						(res && res.erreur && res.erreur.message) ||
						"Mission introuvable.",
				})
			else setEtat({ mission: res, erreur: null })
		})
	}, [dispatch, missionId])
	return (
		<div style={st.zone}>
			{etat.erreur ? (
				<div style={st.erreur}>{etat.erreur}</div>
			) : etat.mission ? (
				<DepMissionCardV2 dep={etat.mission} lectureSeule />
			) : (
				<div style={st.attente}>Chargement de la mission…</div>
			)}
		</div>
	)
}

// Hook commun : ouvert / basculer.
export const useDepliage = () => {
	const [ouvert, setOuvert] = useState(false)
	return [ouvert, () => setOuvert((o) => !o)]
}

const st = {
	chevron: {
		border: `1px solid ${COLORS.border}`,
		backgroundColor: COLORS.surface,
		color: COLORS.textMuted,
		borderRadius: 6,
		width: 22,
		height: 22,
		padding: 0,
		fontSize: 11,
		lineHeight: "20px",
		cursor: "pointer",
		fontFamily: "inherit",
		flexShrink: 0,
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		verticalAlign: "middle",
	},
	zone: { padding: "4px 0 12px" },
	attente: { fontSize: 12.5, color: COLORS.textMuted, padding: "6px 0" },
	erreur: {
		fontSize: 12.5,
		color: COLORS.danger,
		padding: "8px 10px",
		borderRadius: 8,
		backgroundColor: COLORS.dangerLight,
		border: `1px solid ${COLORS.dangerBorder}`,
	},
}
